import * as ACTIONS from "./../actions/actionConstants";

const initialState = {
  anchorEl: null
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.OPEN_MENU: {
      return {
        ...state,
        anchorEl: action.payload
      };
    }
    case ACTIONS.CLOSE_MENU: {
      return {
        ...state,
        anchorEl: null
      };
    }
    default: {
      return state;
    }
  }
};

export default appReducer;



// WEBPACK FOOTER //
// ./src/reducers/menuReducer.js